export const filterQuestions = (randomQuestions, type, subject, topic, year, quizNum, quesNum, snum) => {

  if (subject === "atoz" && topic !== "atoz") {
    return randomQuestions.filter(question =>
      question.topic === topic &&
      question.quiz === quizNum
    ).slice(0, quesNum);
  }
  else if (topic === "atoz" && subject !== "atoz" && type === "previousyearquestions") {
    return randomQuestions.filter(question =>
      question.type === type &&
      question.subject === subject &&
      question.year === year
    );
  }
  else if (topic === "atoz" && subject !== "atoz") {

    if (subject === 'math') {
      const pool = randomQuestions.filter(q =>
        (q.type === "mocktest" || q.type === "chapterwisepyq") &&
        q.subject === subject
      );

      const byTopic = {};
      // Grouping pool items by topic dynamically
      pool.forEach(q => {
        if (!byTopic[q.topic]) byTopic[q.topic] = [];
        byTopic[q.topic].push(q);
      });

      const finalSelection = [];
      const topics = Object.keys(byTopic);
      const topLen = topics.length;

      if (topLen > 0) {
        for (let i = snum; finalSelection.length < quesNum; i++) {
          const currentTopic = topics[i % topLen];
          if (byTopic[currentTopic].length > 0) {
            finalSelection.push(byTopic[currentTopic].shift());
          }
          if (topics.every(t => byTopic[t].length === 0)) break;
        }
      }
      return finalSelection;

    } 
    else if (subject === 'reasoning') {
      const pool = randomQuestions.filter(q =>
        (q.type === "mocktest" || q.type === "chapterwisepyq") &&
        q.subject === subject
      );

      const byTopic = {};
      pool.forEach(q => {
        if (!byTopic[q.topic]) byTopic[q.topic] = [];
        byTopic[q.topic].push(q);
      });

      const finalSelection = [];
      const topics = Object.keys(byTopic);
      const topLen = topics.length;

      if (topLen > 0) {
        for (let i = snum; finalSelection.length < quesNum; i++) {
          const currentTopic = topics[i % topLen];
          if (byTopic[currentTopic].length > 0) {
            finalSelection.push(byTopic[currentTopic].shift());
          }
          if (topics.every(t => byTopic[t].length === 0)) break;
        }
      }
      return finalSelection;

    } 
    else if (subject === 'english') {
      const pool = randomQuestions.filter(q =>
        (q.type === "mocktest" || q.type === "chapterwisepyq") &&
        q.subject === subject
      );

      const byTopic = {};
      pool.forEach(q => {
        if (!byTopic[q.topic]) byTopic[q.topic] = [];
        byTopic[q.topic].push(q);
      });

      const finalSelection = [];
      const topics = Object.keys(byTopic);
      const topLen = topics.length;

      if (topLen > 0) {
        for (let i = snum; finalSelection.length < quesNum; i++) {
          const currentTopic = topics[i % topLen];
          if (byTopic[currentTopic].length > 0) {
            finalSelection.push(byTopic[currentTopic].shift());
          }
          if (topics.every(t => byTopic[t].length === 0)) break;
        }
      }
      return finalSelection;

    } 
    else if (subject === 'gk') {
      const pool = randomQuestions.filter(q =>
        (q.type === "mocktest" || q.type === "chapterwisepyq") &&
        q.subject === subject
      );

      const byTopic = {};
      pool.forEach(q => {
        if (!byTopic[q.topic]) byTopic[q.topic] = [];
        byTopic[q.topic].push(q);
      });

      const finalSelection = [];
      const topics = Object.keys(byTopic);
      const topLen = topics.length;

      if (topLen > 0) {
        for (let i = snum; finalSelection.length < quesNum; i++) {
          const currentTopic = topics[i % topLen];
          if (byTopic[currentTopic].length > 0) {
            finalSelection.push(byTopic[currentTopic].shift());
          }
          if (topics.every(t => byTopic[t].length === 0)) break;
        }
      }
      return finalSelection;
    }

  }
  else if (subject === "atoz" && topic === "atoz" && type === "previousyearquestions") {
    const mathQuestions = randomQuestions.filter(question =>
      question.type === type && question.subject === "math" && question.year === year
    );

    const reasoningQuestions = randomQuestions.filter(question =>
      question.type === type && question.subject === "reasoning" && question.year === year
    );

    const englishQuestions = randomQuestions.filter(question =>
      question.type === type && question.subject === "english" && question.year === year
    );

    const gkQuestions = randomQuestions.filter(question =>
      question.type === type && question.subject === "gk" && question.year === year
    );

    return [
      ...mathQuestions,
      ...reasoningQuestions,
      ...englishQuestions,
      ...gkQuestions
    ];
  } 
  else if (subject === "atoz" && topic === "atoz") {

    const subTarget = Math.round(quesNum / 4);

    const helperSelect = (subName) => {
      const pool = randomQuestions.filter(q =>
        (q.type === "mocktest" || q.type === "chapterwisepyq") && q.subject === subName
      );

      const byTopic = {};
      pool.forEach(q => {
        if (!byTopic[q.topic]) byTopic[q.topic] = [];
        byTopic[q.topic].push(q);
      });

      const topics = Object.keys(byTopic);
      const selection = [];
      
      if (topics.length > 0) {
        for (let i = snum; selection.length < subTarget; i++) {
          const currentTopic = topics[i % topics.length];
          if (byTopic[currentTopic] && byTopic[currentTopic].length > 0) {
            selection.push(byTopic[currentTopic].shift());
          }
          if (topics.every(t => byTopic[t].length === 0)) break;
        }
      }
      return selection;
    };

    // --- 1. MATH SECTION (25%) ---
    const mathSelection = helperSelect("math");

    // --- 2. REASONING SECTION (25%) ---
    const reasoningSelection = helperSelect("reasoning");

    // --- 3. ENGLISH SECTION (25%) ---
    const englishSelection = helperSelect("english");

    // --- 4. GK SECTION (25%) ---
    const gkSelection = helperSelect("gk");

    return [
      ...mathSelection,
      ...reasoningSelection,
      ...englishSelection,
      ...gkSelection
    ];
  }
  else {
    return randomQuestions.filter(question =>
      (question.type === "mocktest" || question.type === "chapterwisepyq") &&
      question.subject === subject &&
      question.topic === topic
    ).slice(0, quesNum);
  }
};